/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Win_Arm_Zip_DescInputs */

const en_pc_dl_file_win_arm_zip_desc = /** @type {(inputs: Pc_Dl_File_Win_Arm_Zip_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unzip and run on Windows on ARM.`)
};

const zh_pc_dl_file_win_arm_zip_desc = /** @type {(inputs: Pc_Dl_File_Win_Arm_Zip_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 ARM 版 Windows 上解压即用。`)
};

/**
* | output |
* | --- |
* | "Unzip and run on Windows on ARM." |
*
* @param {Pc_Dl_File_Win_Arm_Zip_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_win_arm_zip_desc = /** @type {((inputs?: Pc_Dl_File_Win_Arm_Zip_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Win_Arm_Zip_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_win_arm_zip_desc(inputs)
	return zh_pc_dl_file_win_arm_zip_desc(inputs)
});
export { pc_dl_file_win_arm_zip_desc as "pc.dl.file.win_arm_zip.desc" }